import { Box, Header, Text } from '@rbilabs/universal-components';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { spacing } from 'styles/constants';

import theme from './theme';

// item picture
export const StyledPicture = Picture.withConfig({
  maxWidth: '100px',
  height: '68px',
});

// item name
export const Name = Header.withConfig({
  fontFamily: 'heading',
  fontSize: 'md',
  lineHeight: '2xs',
  margin: '$0',
});

// item description
export const StyledDescriptionSanityBlockRenderer = SanityBlockRenderer.withConfig({
  textProps: {
    fontFamily: 'body',
    fontSize: 'sm',
    lineHeight: '2xs',
  },
});

export const StyledLoyaltyPointsIcon = LoyaltyPointsIcon.withConfig({
  fill: theme.itemDescriptionDefaultColor,
  width: '18px',
});

export const RewardItemDescriptionWrapper = Box.withConfig({
  alignItems: 'center',
  flexDirection: 'row',
});

export const RewardItemDescriptionDetail = Text.withConfig({
  fontFamily: 'heading',
  textTransform: 'capitalize',
  fontSize: theme.itemDescriptionFontSize,
  lineHeight: theme.itemDescriptionLineHeight,
  marginLeft: spacing.$0_5,
  color: theme.itemDescriptionDefaultColor,
  fontWeight: theme.itemDescriptionFontWeight,
});
